<template>
  <form 
    class="saved-report-form"
    @submit.prevent=""
  >
    <input
      v-model="savedReport.name"
      :placeholder="$t('DEFAULT_REPORT_NAME')"
      class="f-s-14 form-control"
      type="text"
      @change="onReportNameChange"
    >

    <SaveReportBtn
      v-if="!savedReport.id"
      icon-class="fa fa-floppy-o"
      :disabled="!savedReport.name"
      :label="$t('SAVE')"
      :tooltip="$t('SAVE_TT')"
      :update-only="false"
      :is-admin="isAdmin"
      type="primary"
      @onSaveReport="saveReport"
    />
    
    <SaveReportBtn
      v-if="savedReport.id"
      icon-class="fa fa-floppy-o"
      :disabled="!savedReport.name"
      :label="$t('UPDATE_REPORT')"
      :tooltip="$t('UPDATE_REPORT_TT')"
      :update-only="true"
      type="primary"
      @onSaveReport="saveReport"
    />
    
    <SaveReportBtn
      v-if="savedReport.id"
      icon-class="fa fa-clone"
      :disabled="!savedReport.name"
      :tooltip="$t('SAVE_AS_TT')"
      :is-admin="isAdmin"
      @onSaveReport="saveReportAs"
    />

    <i
      v-if="savedReport.id"  
      v-tooltip.bottom="$t('DELETE_TT')"
      class="btn btn-function fa fa-trash f-s-16 m-l-10"
      @click="showDeleteConfirmationModal"
    />

    <ConfirmationModal
      v-if="showDeleteConfirmation"
      :entity="savedReport"
      :title="$t('DELETE_CONFIRMATION_TITLE')"
      :confirm-action-text="$t('DELETE')"
      @confirm="deleteReport"
      @close="showDeleteConfirmation = false"
    >
      <p v-t="'DELETE_MESSAGE'" />
    </ConfirmationModal>
  </form>
</template>

<script>
import sharedMessages from '@/core/locales';
import messagesCommon from './locales-common';
import messagesInsights from './locales-insights';
import messagesCallLogs from './locales-call-logs';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';
import SaveReportBtn from './SaveReportBtn';

export default {
  name: 'SavedReportForm',
  components: { ConfirmationModal, SaveReportBtn },
  props: {
    savedReport: {
      type: Object,
      default() {
        return {
          name: '',
          id: null
        };
      }
    },
    reportType: {
      type: String,
      default: 'insights'
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDeleteConfirmation: false
    };
  },
  mounted () {
    if (this.reportType === 'callLogs') {
      this.$i18n.mergeLocaleMessage('en', messagesCallLogs.en);
    } else {
      this.$i18n.mergeLocaleMessage('en', messagesInsights.en);
    }
  },
  methods: {
    onReportNameChange(e) {
      e.srcElement.value = this.savedReport.name = e.srcElement.value.trim();
      this.$emit('onReportNameChange', this.savedReport.name);
    },
    showDeleteConfirmationModal() {
      this.showDeleteConfirmation = true;
    },
    deleteReport() {
      this.$emit('onDelete', this.savedReport);
      this.showDeleteConfirmation = false;
    },
    saveReport(visibility) {
      if(this.savedReport.id) {
        this.$emit('onUpdate', this.savedReport);
      } else {
        this.$emit('onSave', visibility);
      }
    },
    saveReportAs(visibility) {
      this.$emit('onSaveAs', visibility);
    }
  },
  i18n: {
    locale: 'en',
    messages: messagesCommon,
    sharedMessages
  }
};
</script>

<style lang="scss" scoped>
.saved-report-form {
  display: flex;
  align-items: center;
  margin-right: auto;
  width: 30%;
  max-width: 300px;
}

@media (max-width: $screen-md-max) {
  .saved-report-form {
    width: 50%;
  }
}

@media (max-width: $screen-xs-max) {
  .saved-report-form {
    width: 95%;
  }
}
</style>